<template>
  <card>
    <list
      v-if="$store.state.user.sections['system_functions']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "dealer",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "system",
          label: "Выберите систему",
          type: "select",
          modal: "system",
          selectKey: "name",
        },
        {
          col: "col-12 col-md-12",
          label: "Название",
          key: "name",
          type: "field",
        },
        {
          col: " col-12 col-md-12",
          key: "command",
          label: "Команда",
          type: "field",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_system_function",
      itemLink: "system_functions",
      setLink: "system_functions",
      columns: [
        {
          key: "name",
          title: "Название функции",
          checkbox: false,

          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "system",
          title: "Система",
          object: "name",
          control: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
